import styles from './LegalPage.module.css';

function TermsPage() {
  return (
    <div className={styles.legalContainer}>
      <div className="page-header">
        <h2>Terms of Service</h2>
      </div>
      <p>
        <strong>Last Updated:</strong> August 25, 2025
      </p>

      <h3>1. Acceptance of Terms</h3>
      <p>
        By creating an account or using our Services, you agree to be bound by
        these Terms of Service and our Privacy Policy. If you do not agree to
        these Terms, you may not access or use the Services.
      </p>

      <h3>2. User Accounts</h3>
      <p>
        You are responsible for safeguarding your account and for all activities
        that occur under your account. You must notify us immediately of any
        unauthorized use of your account. You agree to provide accurate and
        complete information when you create your account and to keep this
        information up to date.
      </p>

      <h3>3. User-Generated Content (UGC)</h3>
      <p>
        You are solely responsible for all content, including but not limited to
        text, images, and personality data, that you create, upload, or share
        through the Services ("Your Content").
      </p>
      <ul>
        <li>
          <strong>Ownership:</strong> You retain all ownership rights to Your
          Content.
        </li>
        <li>
          <strong>License to Us:</strong> By using the Services, you grant Ego a
          worldwide, non-exclusive, royalty-free, sublicensable, and
          transferable license to use, reproduce, distribute, display, and
          perform Your Content solely for the purposes of operating, developing,
          providing, and improving the Services.
        </li>
        <li>
          <strong>Public Content:</strong> If you set a Public Profile or
          Creative Persona to "public," you grant us the right to make that
          specific content publicly available and to allow other users to view
          and interact with it.
        </li>
      </ul>

      <h3>4. Acceptable Use Policy</h3>
      <p>You agree not to post or create any content that:</p>
      <ul>
        <li>Is unlawful, harmful, defamatory, obscene, or hateful.</li>
        <li>
          Constitutes hate speech, incites violence, or promotes discrimination.
        </li>
        <li>
          Infringes on any third party's intellectual property rights, including
          copyright and trademark.
        </li>
        <li>
          Impersonates another person or entity in a deceptive or misleading
          manner.
        </li>
        <li>Contains sexually explicit material or nudity.</li>
      </ul>
      <p>
        We reserve the right, but not the obligation, to remove any content and
        terminate any user account that violates these terms, at our sole
        discretion and without notice.
      </p>

      <h3>5. Copyright Policy (DMCA)</h3>
      <p>
        We respect the intellectual property rights of others. It is our policy
        to respond to any claim that content posted on the Service infringes on
        the copyright of any person. If you are a copyright owner, please submit
        a takedown notice to{' '}
        <a href="mailto:contact@soulstore.ai">contact@soulstore.ai</a> with a
        detailed description of the alleged infringement.
      </p>

      <h3>6. Termination</h3>
      <p>
        We may terminate or suspend your access to the Services at any time,
        without prior notice or liability, for any reason, including if you
        breach these Terms. Upon termination, your right to use the Services
        will immediately cease.
      </p>

      <h3>7. Disclaimers and Limitation of Liability</h3>
      <p>
        The Services are provided on an "AS IS" and "AS AVAILABLE" basis. Ego
        makes no warranties, express or implied, and hereby disclaims all other
        warranties. In no event shall Ego be liable for any indirect,
        incidental, special, consequential, or punitive damages arising out of
        or in connection with your use of the Services.
      </p>

      <h3>8. Governing Law</h3>
      <p>
        These Terms shall be governed by the laws of the State of New Hampshire,
        United States, without regard to its conflict of law provisions.
      </p>

      <h3>9. Contact Us</h3>
      <p>
        If you have questions or comments about these Terms, please contact us
        at: `help@soulstore.ai`
      </p>
    </div>
  );
}

export default TermsPage;
